module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1237.6e57bce7.png";